import { useEffect } from "react";

import { cn } from "@/lib/utils";
import { hideNativeSplash } from "@/lib/native";
import { TWIDO_APP_NAME, TWIDO_LOGO_SRC } from "@/branding";

interface SplashScreenProps {
  exiting?: boolean;
}

/** Centered logo over the wave — fades out as the shell reveals. */
export function SplashScreen({ exiting = false }: SplashScreenProps) {
  // The web splash covers the screen immediately, so hand off from the native
  // splash as soon as it mounts to avoid a flash. No-op on web.
  useEffect(() => {
    const frame = requestAnimationFrame(() => void hideNativeSplash());
    return () => cancelAnimationFrame(frame);
  }, []);

  return (
    <div
      aria-hidden={exiting}
      aria-busy={!exiting}
      className={cn(
        "splash-screen fixed inset-x-0 top-0 z-50 flex items-center justify-center overflow-hidden",
        exiting ? "pointer-events-none" : "pointer-events-auto",
        exiting && "splash-screen--exiting",
      )}
    >
      <div className="splash-screen__logo flex flex-col items-center gap-4">
        <img
          src={TWIDO_LOGO_SRC}
          alt=""
          className="splash-screen__mark size-24 rounded-full shadow-[0_20px_60px_-20px_hsl(var(--neon-blue)/0.45)] sm:size-28"
        />
        <p className="splash-screen__wordmark text-xl font-semibold tracking-tight sm:text-2xl">
          {TWIDO_APP_NAME}
        </p>
      </div>
    </div>
  );
}
